import type { PropsWithChildren } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import { isProfileNotEmpty } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/helpers/common";
import { ProfileAccessLevel } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import type { ProfileDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledSection, StyledSectionName, StyledSharedHint } from "./styles";

type ItemTooltipProps = {
    profile: ProfileDto;
};

const ItemTooltip = (props: PropsWithChildren<ItemTooltipProps>) => {
    const { children, profile } = props;

    function renderSection(array: readonly string[], nameI18nKey: string) {
        return (
            <StyledSection>
                <I18n
                    element={StyledSectionName}
                    translatable={{ key: nameI18nKey }}
                />
                &nbsp;
                {array.join(", ")}
            </StyledSection>
        );
    }

    function wrapWithQuotes(s: string) {
        return `"${s}"`;
    }

    return (
        <PlainTooltip
            placement="top"
            maxWidth={274}
            enabled={isProfileNotEmpty(profile)}
            tooltipContent={
                <div>
                    {profile.departments.length > 0
                        ? renderSection(
                              profile.departments,
                              "si.account-overview.employee-profiles.dropdown.tooltip.department",
                          )
                        : null}
                    {profile.seniority.length > 0
                        ? renderSection(
                              profile.seniority,
                              "si.account-overview.employee-profiles.dropdown.tooltip.seniority",
                          )
                        : null}
                    {profile.includeTitles.length > 0
                        ? renderSection(
                              profile.includeTitles.map(wrapWithQuotes),
                              "si.account-overview.employee-profiles.dropdown.tooltip.title-include",
                          )
                        : null}
                    {profile.excludeTitles.length > 0
                        ? renderSection(
                              profile.excludeTitles.map(wrapWithQuotes),
                              "si.account-overview.employee-profiles.dropdown.tooltip.title-exclude",
                          )
                        : null}
                    {profile.accessLevel === ProfileAccessLevel.Global ? (
                        <I18n
                            element={StyledSharedHint}
                            translatable={{
                                key: "si.account-overview.employee-profiles.dropdown.tooltip.shared-hint",
                            }}
                        />
                    ) : null}
                </div>
            }
        >
            <div>{children}</div>
        </PlainTooltip>
    );
};

export default ItemTooltip;
